"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var register_listeners_1 = __importDefault(require("./register-listeners"));
exports.default = (function (_a) {
    var request = _a.request, files = _a.files, instance = _a.instance, progress = _a.progress, overwriteId = _a.overwriteId;
    return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        if (instance)
            instance(xhr);
        register_listeners_1.default({ xhr: xhr, resolve: resolve, progress: progress });
        xhr.open(request.method || 'POST', overwriteId ? "" + request.url + overwriteId : request.url);
        xhr.withCredentials = request.withCredentials || false;
        if (request.headers) {
            Object.keys(request.headers).forEach(function (header) { return xhr.setRequestHeader(header, request.headers[header]); });
        }
        //send just the file if no fields or filename is set
        if (!request.fileName && !request.fields)
            return xhr.send(files[0]);
        var formData = new FormData();
        //append fields first, fixes https://github.com/expressjs/multer/issues/322
        if (request.fields) {
            Object.keys(request.fields).forEach(function (field) { return formData.append(field, request.fields[field]); });
        }
        Array.from(files).forEach(function (file) { return formData.append(request.fileName || 'file', file); });
        xhr.send(formData);
    });
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/libs/navjobs-upload/request/index.js
// module id = 2559
// module chunks = 0